import React from 'react'
import DatePicker from '../../shared/DatePicker'
import moment from 'moment'
import CustomButton from '../../shared/CustomButton'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

function LabOrderFilters ({ payloadData, setPayloadData, refetch }) {
  const { t } = useTranslation()
  const selectedPatientData = useSelector(
    state => state?.beneficiary?.seletedPatientData
  )

  const handleChange = event => {
    const { name, value } = event.target || {}
    setPayloadData(prevValues => ({
      ...prevValues,
      [name]: moment(value).format('YYYY-MM-DD')
    }))
  }
  const handleApplyFilters = () => {
    let payload = {
      ...payloadData,
      page: 1,
      per_page: 20
    }
    refetch(payload)
    setPayloadData(payload)
  }

  const handleResetFilters = () => {
    let payload = {
      page: 1,
      per_page: 20,
      perPage: 20,
      from_date: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      to_date: moment().format('YYYY-MM-DD'),
      patient_id: selectedPatientData?.patient_id || ''
    }

    refetch(payload)
    setPayloadData(payload)
  }

  return (
    <div className='flex gap-3 mb-2 flex-wrap overflow-x-auto items-start'>
      <div className='flex-none min-w-[180px]'>
        <DatePicker
          name='from_date'
          value={
            payloadData?.from_date
              ? moment(payloadData?.from_date, 'YYYY-MM-DD').toDate()
              : ''
          }
          onChange={handleChange}
          useFormik={false}
          placeholder={t('StartDate')}
        />
      </div>
      <div className='flex-none min-w-[180px]'>
        <DatePicker
          name='to_date'
          value={
            payloadData?.to_date
              ? moment(payloadData?.to_date, 'YYYY-MM-DD').toDate()
              : ''
          }
          onChange={handleChange}
          useFormik={false}
          placeholder={t('EndDate')}
        />
      </div>

      <div className='flex-none flex gap-2 items-center'>
        <CustomButton
          //label={t('ApplyFilters')}
          title={t('ApplyFilters')}
          buttonType='primary'
          icon={'pi pi-filter'}
          className='w-fit h-[35px]'
          onClick={handleApplyFilters}
        />
        <CustomButton
          //label={t('Reset')}
          title={t('Reset')}
          buttonType='reset'
          icon={'pi pi-sync'}
          className='w-fit h-[35px]'
          onClick={handleResetFilters}
        />
      </div>
    </div>
  )
}

export default LabOrderFilters
